import { img, PROJECTS } from "./site";

const p = (id) => PROJECTS.find((x) => x.id === id);

export const RES_SERVICES = [
  { title: "Interior painting", line: "Walls, ceilings, trim, doors and stairwells — prepped properly, finished cleanly." },
  { title: "Exterior painting", line: "Siding, trim, fascia, doors and decks, built to handle Ontario winters." },
  { title: "Cabinet refinishing", line: "Factory-smooth sprayed finishes that make a kitchen feel new without a renovation." },
  { title: "Condos & multi-unit residential", line: "Elevator bookings, building rules and quiet hours handled for you." },
  { title: "Custom colour consultation", line: "Colour, sheen and undertone advice in your own light, at your visit." },
  { title: "Low-VOC & eco paint options", line: "Low- and zero-VOC systems for nurseries, allergies and pets." },
];

export const COMMERCIAL_VERTICALS = [
  { id: "offices", title: "Offices", line: "Repaints on nights and weekends so your team walks into a finished space on Monday.", image: img.office, to: "/commercial/offices" },
  { id: "hospitality", title: "Hospitality", line: "Hotels, restaurants and lobbies refreshed in phases, without closing the doors.", image: img.hotel, to: "/commercial/hospitality" },
  { id: "retail", title: "Retail", line: "Storefronts and floors painted between closing and opening.", image: img.hotelHall, to: null },
  { id: "high-rise", title: "High-Rise & Multi-Unit", line: "Corridors, suites, stairwells and amenity floors, scheduled floor by floor.", image: img.highrise, to: "/commercial/high-rise-multi-unit" },
  { id: "property-managers", title: "Property Managers", line: "One accountable lead, clear documentation and turnover suites done on time.", image: img.highriseWide, to: null },
];

export const QUOTE_DRIVERS = [
  { title: "Prep level", line: "How much filling, sanding, caulking, priming and repair the surfaces need before paint." },
  { title: "Number of coats", line: "One refresh coat over sound paint, or two full coats for colour changes and durability." },
  { title: "Ceilings & trim", line: "Whether ceilings, baseboards, door frames, railings and feature trim are in scope." },
  { title: "After-hours scheduling", line: "Night, weekend or phased work so your business keeps operating during the project." },
  { title: "Access & height", line: "Stairwells, atriums, lifts, scaffolding and building access requirements." },
  { title: "Coating systems", line: "Specialty, high-traffic, washable or low-VOC coatings for the space and its use." },
];

const residentialFaq = (extra) => [
  { q: "How long does the Colour & Scope Visit™ take?", a: "About 30 minutes, in person. Ilias walks every surface with you, talks through colour and finish, and you get a written quote within 24 hours." },
  { q: "Will my home be livable during the job?", a: "Yes. Our dust-free process keeps work contained to sealed zones, and we clean down every day so you can use your home each evening." },
  ...extra,
];

export const SERVICE_PAGES = {
  interior: {
    track: "residential",
    seoTitle: "Interior Painting Toronto | Dust-Free Interior Painters | Amora Painting",
    meta: "Dust-free interior painting across Toronto and the GTA. 30 years, licensed and insured. Free Colour & Scope Visit and a written quote within 24 hours.",
    eyebrow: "Residential · Interior",
    h1: ["Interior painting", "without the mess."],
    intro: "Walls, ceilings, trim, doors, stairwells — painted by a crew that protects your home like it's their own. You get crisp lines, even coverage and a space that's clean at the end of every day.",
    image: img.livingTall,
    wide: img.livingWide,
    highlights: ["Walls, ceilings & trim", "Doors, railings & stairwells", "Feature walls & accent colours", "Drywall and plaster repairs", "Low-VOC & zero-VOC options", "Custom colour consultation"],
    process: [
      { t: "Protect", d: "Furniture moved and covered, floors masked, the work zone sealed off from the rest of your home." },
      { t: "Prepare", d: "Holes filled, cracks repaired, surfaces sanded with vacuum-attached sanders, and primer where it's needed." },
      { t: "Paint", d: "Hand-cut edges and two even coats on the Renew standard, in the sheen that suits each room." },
      { t: "Restore", d: "Daily clean-down, furniture returned, final walkthrough and touch-ups before we call it done." },
    ],
    project: p("junction"),
    tiers: true,
    faqs: residentialFaq([
      { q: "Can you paint while we're living here?", a: "Yes — most of our interior work happens in occupied homes. We sequence rooms so you always have a bedroom, kitchen and bathroom to use." },
      { q: "Do you help choose colours?", a: "Yes. Custom colour consultation is part of your Colour & Scope Visit™. We look at your light, your floors and your furniture before suggesting anything." },
    ]),
  },
  exterior: {
    track: "residential",
    seoTitle: "Exterior House Painting Toronto & GTA | Amora Painting",
    meta: "Exterior painting for Toronto and GTA homes and cottages. Siding, trim, doors and decks prepped to last through Ontario winters. Free assessment.",
    eyebrow: "Residential · Exterior",
    h1: ["Curb appeal,", "built to weather."],
    intro: "Ontario weather is hard on paint. We prep every exterior surface properly — scraping, sanding, caulking and priming — so the finish holds through freeze, thaw and summer sun. From city semis to Muskoka cottages.",
    image: img.exterior,
    wide: img.exteriorWide,
    highlights: ["Siding, soffits & fascia", "Window and door trim", "Front doors & shutters", "Decks, fences & railings", "Brick and stucco coatings", "Cottage country exteriors"],
    process: [
      { t: "Inspect", d: "We check for peeling, rot, moisture and failed caulking before a brush ever touches the house." },
      { t: "Prepare", d: "Wash, scrape, sand and caulk. Bare spots primed. Gardens, walkways and windows protected." },
      { t: "Coat", d: "Exterior-grade systems applied in the right weather window, with two coats on the Renew standard." },
      { t: "Clean up", d: "Paint chips collected, site left tidy, final walkthrough and touch-ups with you." },
    ],
    project: p("oakville"),
    tiers: true,
    faqs: residentialFaq([
      { q: "When is exterior painting season?", a: "Generally late spring through early fall, when temperatures and humidity are right for exterior coatings. Book your visit early to get the dates you want." },
      { q: "Do you paint cottages?", a: "Yes. We regularly travel to Muskoka, the Kawarthas, Haliburton and Georgian Bay. We plan the crew, materials and schedule around the trip." },
    ]),
  },
  cabinets: {
    track: "residential",
    seoTitle: "Cabinet Refinishing & Condo Painting Toronto | Amora Painting",
    meta: "Kitchen cabinet refinishing and condo painting in Toronto and the GTA. Smooth, durable finishes, building rules handled. Free Colour & Scope Visit.",
    eyebrow: "Residential · Cabinets & Condos",
    h1: ["A new kitchen,", "without the reno."],
    intro: "Cabinet refinishing gives you a factory-smooth, durable finish on the cabinets you already have. And for condos and multi-unit homes, we handle elevator bookings, building rules and quiet hours so you don't have to.",
    image: img.kitchen,
    wide: img.kitchenWide,
    highlights: ["Kitchen cabinet refinishing", "Bathroom vanities & built-ins", "Smooth sprayed finishes", "Condo suites & lofts", "Building rules & elevator bookings", "Low-odour, low-VOC systems"],
    process: [
      { t: "Remove", d: "Doors and drawer fronts labelled and removed. Hardware bagged. Counters and appliances covered." },
      { t: "Prepare", d: "Degreased, sanded and primed with a bonding primer so the finish actually sticks." },
      { t: "Finish", d: "Durable cabinet-grade coatings applied for a smooth, even surface — no brush marks." },
      { t: "Reinstall", d: "Doors rehung, hinges adjusted, hardware back on, kitchen cleaned and ready to use." },
    ],
    project: p("kitchen"),
    tiers: true,
    faqs: residentialFaq([
      { q: "How long until I can use my kitchen?", a: "We confirm timing at your visit based on the number of doors and the finish. Your written quote includes the exact schedule." },
      { q: "Can you work within my condo's rules?", a: "Yes. We coordinate with your property manager, book elevators, follow noise windows and provide insurance documents when the building asks." },
    ]),
  },
  offices: {
    track: "commercial",
    vertical: "offices",
    seoTitle: "Commercial Office Painting Toronto & Ontario | Amora Painting",
    meta: "Office painting in Toronto, the GTA and across Ontario. After-hours scheduling, dust-free process, one accountable project lead. Request a site walkthrough.",
    eyebrow: "Commercial · Offices",
    h1: ["Your office, repainted", "over the weekend."],
    intro: "Teams shouldn't work around a paint crew. We schedule office repaints on nights and weekends, keep dust contained to sealed zones, and hand back a finished floor before Monday morning.",
    image: img.office,
    wide: img.officeHall,
    highlights: ["Open-plan floors & boardrooms", "Reception & feature walls", "Corridors, doors & frames", "Night and weekend scheduling", "Phased work around occupied floors", "Washable, high-traffic coatings"],
    process: [
      { t: "Walkthrough", d: "A project lead walks the site with your facilities team and maps the phases." },
      { t: "Schedule", d: "Written quote and a phased schedule built around your business hours." },
      { t: "Execute", d: "Sealed, dust-free zones, protected furniture and IT, and a clean floor each morning." },
      { t: "Hand over", d: "Final walkthrough with your team, touch-ups, and a 1-year limited workmanship warranty." },
    ],
    project: p("office"),
    tiers: false,
    faqs: [
      { q: "Can you work after hours?", a: "Yes. Night, weekend and phased scheduling is standard on our commercial work. It's itemized in your quote so you can see exactly what it covers." },
      { q: "Do you carry insurance for commercial sites?", a: "Yes, Amora Painting is licensed and insured. We provide certificates to building management on request." },
      { q: "What warranty do you offer?", a: "Commercial work is backed by a 1-year limited workmanship warranty, written into your quote." },
    ],
  },
  hospitality: {
    track: "commercial",
    vertical: "hospitality",
    seoTitle: "Hospitality & Retail Painting Toronto | Hotels, Restaurants | Amora Painting",
    meta: "Hotel, restaurant and retail painting across Toronto and Ontario. Phased schedules that keep you open, dust-free process, written quote within 24 hours.",
    eyebrow: "Commercial · Hospitality & Retail",
    h1: ["Stay open.", "Look brand new."],
    intro: "Hotels, restaurants, lobbies and retail floors can't close for a paint job. We phase the work by floor, wing or zone, keep it contained and quiet, and leave every area guest-ready at the end of each shift.",
    image: img.hotelHall,
    wide: img.hotel,
    highlights: ["Hotel rooms & corridors", "Lobbies & reception areas", "Restaurants & dining rooms", "Retail floors & storefronts", "Phased, zone-by-zone scheduling", "Durable, scrubbable finishes"],
    process: [
      { t: "Walkthrough", d: "We map zones, guest flow and operating hours with your manager." },
      { t: "Phase", d: "A written plan that keeps rooms, tables or aisles open while we work." },
      { t: "Execute", d: "Dust-free, low-odour work, cleaned down and guest-ready every shift." },
      { t: "Hand over", d: "Zone-by-zone sign-off, touch-ups and a 1-year limited workmanship warranty." },
    ],
    project: p("office"),
    tiers: false,
    faqs: [
      { q: "Can you work around guests?", a: "Yes. We phase work by room block, floor or zone and use low-odour products so guests and diners aren't disrupted." },
      { q: "Do you handle retail chains?", a: "Yes. We've worked with teams at brands like Tim Hortons and can coordinate multiple locations across Ontario." },
    ],
  },
  "high-rise": {
    track: "commercial",
    vertical: "high-rise",
    seoTitle: "High-Rise & Multi-Unit Painting Toronto | Condo Corridors | Amora Painting",
    meta: "Painting for high-rise and multi-unit buildings across Toronto and Ontario. Corridors, suites, stairwells, amenity floors. One project lead, scheduled floor by floor.",
    eyebrow: "Commercial · High-Rise & Multi-Unit",
    h1: ["Floor by floor.", "On schedule."],
    intro: "Corridors, suites, stairwells, lobbies and amenity floors — scheduled floor by floor with your property manager. Residents get clear notices, the building gets one accountable lead, and the board gets a finish date it can count on.",
    image: img.highrise,
    wide: img.highriseWide,
    highlights: ["Corridors & elevator lobbies", "Suite turnovers", "Stairwells & parking garages", "Amenity floors & lobbies", "Resident notices & scheduling", "Property manager reporting"],
    process: [
      { t: "Walkthrough", d: "Site walk with the property manager to map floors, access and resident impact." },
      { t: "Plan", d: "Written quote with floor-by-floor phasing, notices and building requirements." },
      { t: "Execute", d: "Dust-free, contained work and a clean corridor at the end of each day." },
      { t: "Report", d: "Floor sign-offs, touch-ups and a 1-year limited workmanship warranty." },
    ],
    project: p("junction"),
    tiers: false,
    faqs: [
      { q: "Do you work with property managers and condo boards?", a: "Yes. One project lead is your point of contact from walkthrough to final sign-off, with updates as each floor completes." },
      { q: "How do you handle residents?", a: "We prepare notices, follow building quiet hours, keep corridors passable and clean up every day." },
    ],
  },
};
